import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { TranslocoDirective } from "@jsverse/transloco";

/**
 * Full-screen page shown once billingBlockLevel reaches 4 (see BillingBlockGuard).
 * Registered at the app root, outside CoreComponent, so no toolbar/sidenav or any
 * other platform feature is reachable from here. Leaving the page once the block is
 * lifted is handled app-wide by BillingBlockRedirectService.
 */
@Component({
    selector: "app-account-blocked",
    templateUrl: "./account-blocked.component.html",
    styleUrl: "./account-blocked.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, TranslocoDirective],
})
export class AccountBlockedComponent {}
